const defaultState = {}

export const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_ALL_USERS':
      return {
        ...action.payload
      }
    default:
      return state
  }
}
